// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Link-module__link--1NNx6{text-decoration:none;font-weight:bold;color:#09c}", ""]);
// Exports
exports.locals = {
	"link": "Link-module__link--1NNx6"
};
module.exports = exports;
